import React from 'react';
import { Container, Typography, Button, Box, Link } from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { useTheme } from '@mui/material/styles';
import { Link as RouterLink } from 'react-router-dom';

const Footer = () => {
    const theme = useTheme();

    const handleScrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    return (
        <Container component="footer" style={{ padding: '5px', backgroundColor: theme.palette.background.default, textAlign: 'center' }}>
            <Button
                variant="contained"
                color="primary"
                onClick={handleScrollToTop}
            ><ArrowUpwardIcon />
            </Button>
            <Box sx={{ mt: 3 }}>
                <Link component={RouterLink} to="/contact"
                sx={{
                    fontSize: '1.15rem',
                    textDecoration: 'none',
                    color: theme.palette.text.primary,
                    '&:hover': {
                        color: theme.palette.primary.main,
                    }
                }}>
                    Contact
                </Link>
            </Box>
            <Typography variant="body2" color="textSecondary" sx={{ fontSize: '0.8rem', mt: 2 }} gutterBottom>
                I DID IT MY WAY LLC
            </Typography>
            <Typography variant="body1" gutterBottom>
                Eli Music Catalog
            </Typography>
            <Box sx={{ mt: 2 }}>
                <img
                    src={process.env.PUBLIC_URL + theme.palette.mode === 'dark' ? "/WhiteKnowledgeLogo.png" : "/BlackKnowledgeLogo.png"}
                    alt="BlackKnowledge Logo"
                    width="75"
                    height=""
                />
            </Box>
        </Container>
    );
};

export default Footer;
